// extracted by mini-css-extract-plugin
export default {"localPermissions":"ProjectUpdateForm_localPermissions__hV0GC"};